require('./bootstrap');

import "core-js/actual/queue-microtask";
import "core-js/actual/array/flat-map";

import feather from 'feather-icons';

window.feather = feather;

import "./initReleases";
import "./initRegister";

import {paymentMethods as __dLocalGoPaymentMethods} from "./dLocalGoPaymentMethods";
window.dLocalGoPaymentMethodsByCountry = __dLocalGoPaymentMethods;

import './alpine_ui';

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import mask from '@alpinejs/mask';

Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(mask);

window.Alpine = Alpine;

import debounce from 'lodash/debounce';
window.debounce = debounce;

require('jquery-ui/ui/widgets/autocomplete');
require('jquery-ui/themes/base/autocomplete.css');

require('select2');
require('select2/dist/css/select2.css');

import choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.css';
window.Choices = choices;

require('./common');

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

    // Tooltip
document.addEventListener('alpine:init', () => {
    // Magic: $tooltip
    Alpine.magic('tooltip', el => message => {
        let instance = tippy(el, { content: message, trigger: 'manual' })

        instance.show()

        setTimeout(() => {
            instance.hide()

            setTimeout(() => instance.destroy(), 150)
        }, 2000)
    })

    // Directive: x-tooltip
    Alpine.directive('tooltip', (el, { expression }) => {
        tippy(el, { content: expression })
    })
});